// AmpAlert — 3-color AMP cross-promo (brown + green + white).
// Replaces AmpPitch.tsx. The visual difference is the icon disk: it's now
// solid green inside the brown promo, with a subtle white ring around it.
// Three distinct colors break up the previous brown+white two-tone flatness.

import { Sprout, ArrowRight } from 'lucide-react';

export function AmpAlert() {
  return (
    <aside className="mb-10">
      <div className="rounded-3xl md:rounded-full bg-uif-brown-dark text-white shadow-lg">
        <div className="flex flex-col md:flex-row md:items-center gap-5 px-6 py-6 md:px-8 md:py-5">
          {/* Round icon badge on the left — green disk with white ring. */}
          <div className="flex-shrink-0 h-14 w-14 rounded-full bg-uif-green flex items-center justify-center ring-2 ring-white/25 shadow-md">
            <Sprout className="h-7 w-7 text-white" />
          </div>

          {/* Copy column — left-aligned (definitely not centered). */}
          <div className="flex-1 text-left">
            <p className="font-bold text-base md:text-lg leading-snug text-white">
              Are you a small farm interested in funding for conservation, production, and food safety?
            </p>
            <p className="text-xs md:text-sm text-white/75 mt-1">
              USDA Advancing Markets for Producers — operated locally by Up in Farms.
            </p>
          </div>

          {/* CTA chip — white pill on the brown field. */}
          <a
            href="/#amp"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-uif-brown-dark font-semibold px-5 py-2.5 hover:bg-uif-brown-light hover:text-white transition-colors whitespace-nowrap flex-shrink-0"
          >
            Click here for more information
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </aside>
  );
}
